import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import get from 'lodash/get';

import { SvgIcon, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { colors } from '@hydra/common/styles';

import settings from '@hydra/utils/settings';

const fillToColor = {
  default: colors.grey[500],
  white: colors.common.white,
  primary: colors.primary.main,
  'primary-dark': colors.primary.dark,
  warning: colors.warning.main,
  'warning-dark': colors.warning.dark,
  error: colors.error.main,
  'error-dark': colors.error.dark,
  success: colors.success.main,
  'success-dark': colors.success.dark,
  grey: colors.grey[500],
  'grey-medium': colors.grey[400],
  'grey-light': colors.grey[300],
  'grey-dark': colors.grey[900]
};

// This map is the source of truth:
const sizeAsPx = {
  xxs: 10, // 10px
  xs: 13, // 13px
  sm: 16, // 16px
  md: 20, // 20px
  base: 24, // 24px
  lg: 32, // 32px
  '2x': 48, // 48px
  '3x': 64, // 64px
  '4x': 128 // 128px
};

function sizeToStyles (size) {
  const px = sizeAsPx[size];
  return { width: px, height: px };
}

const useStyles = makeStyles(theme => ({
  xxs: sizeToStyles('xxs'),
  xs: sizeToStyles('xs'),
  sm: sizeToStyles('sm'),
  md: sizeToStyles('md'),
  base: sizeToStyles('base'),
  lg: sizeToStyles('lg'),
  '2x': sizeToStyles('2x'),
  '3x': sizeToStyles('3x'),
  '4x': sizeToStyles('4x')
}));

export default function Icon (props) {
  const {
    type,
    size,
    color: colorProp,
    className: classNameProp,
    ...others
  } = props;

  const classes = useStyles();

  const assetPath = settings.get('iconPath');

  const iconClasses = classnames(
    classes[size],
    classNameProp
  );

  const color = get(fillToColor, colorProp, colorProp);

  return (
    type === 'loader'
      ? (
        <CircularProgress
          className={iconClasses}
          size={sizeAsPx[size]}
          disableShrink
          color='inherit'
          style={{ color }}
          thickness={4}
        />
        )
      : (
        <SvgIcon
          className={iconClasses}
          htmlColor={color}
          {...others}
        >
          <use xlinkHref={`${assetPath}#${type}`} />
        </SvgIcon>
        )
  );
}

Icon.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string.isRequired,
  color: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(Object.keys(sizeAsPx)),
  viewBox: PropTypes.string,
  component: PropTypes.string
};

Icon.defaultProps = {
  color: 'default',
  size: 'base'
};
